import React, { useMemo } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { useSelector } from "react-redux";
import { ScrollShadow } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { getConfigOption } from "~/store/selectors/selector.configOptions";
import { getLoggedUser } from "~/store/selectors/selector.users";
import { isFinancialManager, isPowerUser } from "~/utils/userHelper";
import { TeamMemberItem } from "./TeamMemberItem";

export const TeamMembersList = ({ users, className, onClick, onChange, isLoading }) => {
  const loggedUser = useSelector(getLoggedUser);
  const availabilityEnabled = useSelector((state) => getConfigOption(state, `availability_enabled`));
  const workloadEnabled = useSelector((state) => getConfigOption(state, `workload_enabled`));
  const isUserPowerUser = isPowerUser(loggedUser);
  const isUserFinancialManager = isFinancialManager(loggedUser);

  const canSeeCapacity = useMemo(
    () => (availabilityEnabled || workloadEnabled) && (isUserFinancialManager || isUserPowerUser),
    [availabilityEnabled, isUserFinancialManager, isUserPowerUser, workloadEnabled]
  );

  if (users.length === 0) {
    return null;
  }

  return (
    <ScrollShadow disableHorizontal>
      {({ onScroll }) => (
        <Scrollbars
          autoHeight
          className={classNames("tw-h-full", className)}
          autoHeightMin={0}
          autoHeightMax={132} // Shows three and a half items
          onScroll={onScroll}
          ref={null}
        >
          <div>
            {users.map((user, index) => (
              <TeamMemberItem
                key={index}
                user={user}
                onClick={onClick}
                onChange={onChange}
                isLoading={isLoading}
                showCapacity={canSeeCapacity}
              />
            ))}
          </div>
        </Scrollbars>
      )}
    </ScrollShadow>
  );
};

TeamMembersList.propTypes = {
  users: PropTypes.arrayOf(PropTypes.object).isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  isLoading: PropTypes.bool,
};

TeamMembersList.defaultProps = {
  users: [],
  className: "",
};
